/**
 * GENERATED FILE — do not edit. Regenerate with:
 *   node tools/scripts/generate-plugin-manifests.mjs
 *
 * The plugins' DECLARATIONS (AGL-2939): the light registrations core
 * reads before any plugin surface loads, imported dynamically like the
 * loader manifests. One of the sanctioned @aglyn/plugins-* references
 * outside libs/plugins (AGL-417).
 * Source of truth: plugins.config.json.
 */
/* eslint-disable @nx/enforce-module-boundaries */

let done: Promise<void> | undefined

/** Registers every plugin's client declarations once per process. */
export function registerPluginDeclarations(): Promise<void> {
  done ??= (async () => {
    ;(await import('@aglyn/plugins-commerce/declarations')).registerCommerceDeclarations()
    ;(await import('@aglyn/plugins-crm/declarations')).registerCrmDeclarations()
    ;(await import('@aglyn/plugins-outreach/declarations.console')).registerOutreachConsoleDeclarations()
    ;(await import('@aglyn/plugins-accounting/declarations.console')).registerAccountingConsoleDeclarations()
    ;(await import('@aglyn/plugins-workflows/declarations')).registerWorkflowsDeclarations()
    ;(await import('@aglyn/plugins-ai/declarations')).registerAiDeclarations()
    ;(await import('@aglyn/plugins-waivers/declarations')).registerWaiversDeclarations()
    ;(await import('@aglyn/plugins-weglot/declarations')).registerWeglotDeclarations()
  })()
  return done
}
